"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgSignals1 = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_SIGNALS-1", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M1.076 2.035C1.38 2.012 1.689 2 2 2c6.627 0 12 5.373 12 12 0 .311-.012.62-.035.924a1 1 0 0 0 1.994.152c.027-.355.041-.714.041-1.076C16 6.268 9.732 0 2 0 1.638 0 1.28.014.924.04a1 1 0 0 0 .152 1.995Z" }),
    React.createElement("path", { d: "M2 6c-.301 0-.598.017-.89.049A1 1 0 1 1 .89 4.06 10.1 10.1 0 0 1 2 4c5.523 0 10 4.477 10 10 0 .375-.02.745-.061 1.11a1 1 0 0 1-1.988-.22A8 8 0 0 0 2 6Z" }),
    React.createElement("path", { d: "M1.199 10.08a4 4 0 0 1 4.721 4.721 1 1 0 0 0 1.96.398A6 6 0 0 0 .801 8.12a1 1 0 0 0 .398 1.96Z" }),
    React.createElement("path", { d: "M2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }))); };
exports.default = SvgSignals1;
